// extracted by mini-css-extract-plugin
export default {"container":"box_container__xVTMS","details":"box_details__RCtQe","title":"box_title__3QJ5V"};